(() => {
  const SELECTOR = '[data-sk27-product]';

  function parseJSON(node) {
    try {
      return JSON.parse(node?.textContent || '[]');
    } catch (error) {
      console.warn('ScrubKix product data could not be parsed.', error);
      return [];
    }
  }

  function money(cents, currency) {
    const locale = document.documentElement.lang || 'en-US';
    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency || 'USD'
      }).format(Number(cents || 0) / 100);
    } catch (_error) {
      return `$${(Number(cents || 0) / 100).toFixed(2)}`;
    }
  }

  function initGallery(root) {
    const mainImage = root.querySelector('[data-sk27-main-image]');
    const mainSource = root.querySelector('[data-sk27-main-source]');
    const thumbs = Array.from(root.querySelectorAll('[data-sk27-gallery-thumb]'));

    if (!mainImage || !thumbs.length) return;

    function show(button, focusMain = false) {
      const nextFull = button.dataset.fullSrc;
      const nextMobile = button.dataset.mobileSrc || nextFull;
      const nextAlt = button.dataset.alt || '';

      if (nextFull) mainImage.src = nextFull;
      if (nextMobile && mainSource) mainSource.srcset = nextMobile;
      mainImage.alt = nextAlt;

      thumbs.forEach((thumb) => thumb.setAttribute('aria-current', String(thumb === button)));
      if (focusMain) mainImage.focus({ preventScroll: true });
    }

    thumbs.forEach((button) => {
      button.addEventListener('click', () => show(button));
    });

    root.addEventListener('sk27:color', (event) => {
      const color = String(event.detail?.color || '').toLowerCase();
      const match = thumbs.find((thumb) => String(thumb.dataset.color || '').toLowerCase() === color);
      if (match) show(match);
    });
  }

  function initProduct(root) {
    if (root.dataset.sk27Ready === 'true') return;
    root.dataset.sk27Ready = 'true';

    const form = root.querySelector('[data-sk27-product-form]');
    const variants = parseJSON(root.querySelector('[data-sk27-variants]'));
    const optionSelects = Array.from(root.querySelectorAll('[data-sk27-option]'));
    const idInput = root.querySelector('[data-sk27-variant-id]');
    const priceNode = root.querySelector('[data-sk27-price]');
    const compareNode = root.querySelector('[data-sk27-compare]');
    const submitButton = root.querySelector('[data-sk27-submit]');
    const statusNode = root.querySelector('[data-sk27-status]');
    const mobileButton = document.querySelector(`[data-sk27-mobile-submit="${root.id}"]`);
    const mobilePrice = document.querySelector(`[data-sk27-mobile-price="${root.id}"]`);
    const packCards = Array.from(root.querySelectorAll('[data-sk27-pack]'));
    const currency = root.dataset.currency || 'USD';

    initGallery(root);

    function selectedOptions() {
      return optionSelects.map((select) => select.value);
    }

    function findVariant() {
      const values = selectedOptions();
      return variants.find((variant) =>
        values.every((value, index) => String(variant.options?.[index]) === String(value))
      );
    }

    function selectedColor() {
      const select = optionSelects.find((node) => node.dataset.optionName === 'Color');
      return select?.value || '';
    }

    function selectedPack() {
      const select = optionSelects.find((node) => node.dataset.optionName === 'Pack Size');
      return select?.value || '';
    }

    function update() {
      const variant = findVariant();
      const available = Boolean(variant?.available);
      const label = variant ? (available ? 'Add to cart' : 'Sold out') : 'Unavailable';

      if (idInput) idInput.value = variant?.id || '';
      if (priceNode) priceNode.textContent = variant ? money(variant.price, currency) : 'Unavailable';
      if (mobilePrice) mobilePrice.textContent = variant ? money(variant.price, currency) : '';

      if (compareNode) {
        const showCompare = Boolean(variant?.compare_at_price && variant.compare_at_price > variant.price);
        compareNode.hidden = !showCompare;
        compareNode.textContent = showCompare ? money(variant.compare_at_price, currency) : '';
      }

      [submitButton, mobileButton].forEach((button) => {
        if (!button) return;
        button.disabled = !available;
        button.textContent = label;
      });

      if (statusNode) {
        statusNode.textContent = variant
          ? (available ? 'Ready to add. Shipping is calculated at checkout.' : 'This option is currently unavailable.')
          : 'Choose an available color and pack size.';
      }

      const pack = selectedPack();
      packCards.forEach((card) => card.setAttribute('aria-pressed', String(card.dataset.sk27Pack === pack)));

      root.dispatchEvent(new CustomEvent('sk27:color', { detail: { color: selectedColor() } }));
    }

    optionSelects.forEach((select) => select.addEventListener('change', update));

    packCards.forEach((card) => {
      card.addEventListener('click', () => {
        const packSelect = optionSelects.find((node) => node.dataset.optionName === 'Pack Size');
        if (!packSelect) return;
        packSelect.value = card.dataset.sk27Pack;
        packSelect.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    if (mobileButton && form) {
      mobileButton.addEventListener('click', () => {
        if (typeof form.requestSubmit === 'function') form.requestSubmit(submitButton || undefined);
        else form.submit();
      });
    }

    update();
  }

  function init(scope = document) {
    scope.querySelectorAll(SELECTOR).forEach(initProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
